<template>
  <!--infiniteList无限加载商品列表-->
  <div v-if="productsData.length">
    <tk-flex
      v-if="isTitle"
      style="font-size: 16px;"
      center middle
      class="font-bold m-y-8"
    >
      <tk-image :src="'https://s3.moke.cloud/dianpei/ef61cc68-2d68-4d25-a84c-cee2289b7100.png'" height="13" width="16"></tk-image>
      <div class="p-x-4" :style="{color: color}">{{title}}</div>
      <tk-image :src="'https://s3.moke.cloud/dianpei/b32226ef-e8b1-4958-8f28-4349ee94f871.png'" height="13" width="16"></tk-image>
    </tk-flex>
    <tk-flex wrap :class="infiniteListPad" gutter="9">
      <card
        :width="100"
        :height="50"
        class="tk-grid-6 m-t-10 p-0 class-recommended"
        v-for="(s, index) in productsData"
        @click.native="nextPage(s)"
        :key="`imgRef${index}`"
      >
        <div class="class-recommended-img">
          <tk-image :src="s.showPictures[0]" height="168" class="class-recommended-image"></tk-image>
        </div>
        <div class="p-x-10 font-14 m-t-2 van-ellipsis">{{s.productTitle}}</div>
        <!--卖点-->
        <div class="van-ellipsis m-t-2 p-x-10 caption">{{s.selling ? s.selling : '无卖点信息'}}</div>
        <div v-if="s.oldPrice" class="p-b-8 m-t-2">
          <div class="m-l-10 class-card-red">
            <span class="font-10">￥</span>{{s.price}} <span class="font-12 m-l-10 class-card-decoration caption"><span class="font-10">￥</span>{{s.oldPrice}}</span>
          </div>
        </div>
        <div v-else class="m-l-10 p-b-8 class-card-red font-bold"><span class="font-10">￥</span>{{s.price}}</div>
      </card>
    </tk-flex>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    productsData: {
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: '#000000',
      required: true
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    infiniteListPad: {
      type: String,
      default: 'p-x-15'
    }
  },
  computed: {
  },
  async mounted () {
    await this.$tkHelper.sleep(1000)
    this.$forceUpdate()
  },
  methods: {
    nextPage (s) {
      if (this.$route.path === '/commodity/productDetails') {
        this.$push({ path: '/commodity/newProductDetails', query: { id: s.objectId } })
        return
      }
      this.$push({ path: '/commodity/productDetails', query: { id: s.objectId } })
    }
  }
}
</script>

<style lang="scss" scoped>
  /*商品列表样式*/
  .class-recommended {
    border-radius: 5px;
    overflow: hidden;
    /*border: 1px solid #fafafa;*/
    .class-card-red {
      color: rgba(250, 51, 51, 1);
    }
    .class-card-black {
      word-wrap: break-word;
      word-break: break-all;
      width: 105px;
      color: #000000;
    }
  }
</style>
